import { Routes } from '@angular/router';
import { routes as dashboardRoutes } from './dashboard.routes';
import { routes as errorRoutes } from './error.routes';
import { routes as machineRangeRoutes } from './machine-range.routes';
import { routes as machineRoutes } from './machine.routes';
import { routes as settingsRoutes } from './settings.routes';
import { contentListResolver } from 'src/app/shared/resolvers/content-list.resolver';
import { AuthenticationGuard, AuthorisationGuard } from 'src/app/core/guards/authentication.guard';
import { regionResolver } from 'src/app/shared/resolvers/region.resolver';
import { NotFoundComponent } from 'src/app/core/pages/not-found/not-found.component';
import { DashboardLayoutComponent } from 'src/app/core/layouts/dashboard-layout/dashboard-layout';

export const routes: Routes = [
  {
    path: '',
    resolve: { contentList: contentListResolver, regions: regionResolver },
    canActivate: [AuthenticationGuard, AuthorisationGuard],
    children: [
      ...dashboardRoutes,
      ...machineRangeRoutes,
      ...machineRoutes,
      ...settingsRoutes,
    ]
  },
  ...errorRoutes,
  {
    path: 'not-found',
    pathMatch: 'full',
    component: DashboardLayoutComponent,
    children: [{
      path: '',
      pathMatch: 'full',
      component: NotFoundComponent,
    }],
  },
  {
    path: '**',
    pathMatch: 'full',
    component: DashboardLayoutComponent,
    children: [{
      path: '',
      pathMatch: 'full',
      component: NotFoundComponent,
    }],
  }
];
